const SVG_NS = 'http://www.w3.org/2000/svg';
const SCALE = 2;
const TITLE_BAND = 32;
const PNG_TEXT = '#010057';

function loadImage(url) {
    return new Promise((resolve, reject) => {
        const image = new window.Image();
        image.onload = () => resolve(image);
        image.onerror = () =>
            reject(new Error('The chart could not be drawn.'));
        image.src = url;
    });
}

/**
 * Render the chart inside `container` to a PNG blob.
 *
 * The SVG is serialized and drawn onto a canvas at twice its size on a white
 * ground, under a title band, so the saved image is readable on a slide
 * without the page around it. The serialized copy carries the font of the
 * page because an SVG loaded as an image does not inherit one. Colors in the
 * chart are literal values for the same reason (see palette.js).
 */
export async function chartToPngBlob(container, title) {
    const svg = container.querySelector('svg.recharts-surface');
    if (!svg) {
        throw new Error('There is no chart to save.');
    }
    const { width, height } = svg.getBoundingClientRect();
    const clone = svg.cloneNode(true);
    clone.setAttribute('xmlns', SVG_NS);
    clone.setAttribute('width', String(width));
    clone.setAttribute('height', String(height));
    clone.setAttribute(
        'font-family',
        window.getComputedStyle(container).fontFamily || 'sans-serif'
    );
    const markup = new window.XMLSerializer().serializeToString(clone);
    const url = URL.createObjectURL(
        new Blob([markup], { type: 'image/svg+xml;charset=utf-8' })
    );
    try {
        const image = await loadImage(url);
        const canvas = document.createElement('canvas');
        canvas.width = Math.ceil(width * SCALE);
        canvas.height = Math.ceil((height + TITLE_BAND) * SCALE);
        const context = canvas.getContext('2d');
        context.scale(SCALE, SCALE);
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, width, height + TITLE_BAND);
        context.fillStyle = PNG_TEXT;
        context.font = 'bold 14px sans-serif';
        context.fillText(title, 8, 21);
        context.drawImage(image, 0, TITLE_BAND, width, height);
        return await new Promise((resolve, reject) => {
            canvas.toBlob(
                (blob) =>
                    blob
                        ? resolve(blob)
                        : reject(new Error('The image could not be saved.')),
                'image/png'
            );
        });
    } finally {
        URL.revokeObjectURL(url);
    }
}
